/**
 * Parse `tenants.settings.pilot` slice from raw tenant settings JSON.
 */

import { isPilotSurfaceId } from '@shared/platform/pilot-surface-registry';
import {
  isTenantPilotAiMode,
  isTenantPilotPresetId,
  type TenantPilotSettings,
} from '@shared/types/tenant-pilot-settings';

export function parseTenantPilotSettings(raw: unknown): TenantPilotSettings {
  if (!raw || typeof raw !== 'object') {
    return { pilotMode: false };
  }

  const pilot = (raw as Record<string, unknown>).pilot;
  if (!pilot || typeof pilot !== 'object') {
    return { pilotMode: false };
  }

  const record = pilot as Record<string, unknown>;
  const settings: TenantPilotSettings = {
    pilotMode: record.pilotMode === true,
  };

  if (typeof record.pilotPresetId === 'string' && isTenantPilotPresetId(record.pilotPresetId)) {
    settings.pilotPresetId = record.pilotPresetId;
  }

  if (typeof record.aiMode === 'string' && isTenantPilotAiMode(record.aiMode)) {
    settings.aiMode = record.aiMode;
  }

  if (Array.isArray(record.enabledSurfaces)) {
    const enabled = record.enabledSurfaces.filter(
      (value): value is string => typeof value === 'string' && isPilotSurfaceId(value)
    );
    if (enabled.length > 0) {
      settings.enabledSurfaces = enabled;
    }
  }

  if (Array.isArray(record.hiddenSurfaces)) {
    const hidden = record.hiddenSurfaces.filter(
      (value): value is string => typeof value === 'string' && isPilotSurfaceId(value)
    );
    if (hidden.length > 0) {
      settings.hiddenSurfaces = hidden;
    }
  }

  return settings;
}
